import React, { useEffect } from 'react';
import { Container, Card, Alert, Button, Row, Col } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import colors from '../../constants/colors';

const MultibancoPaymentPage = () => {
  const location = useLocation();
  const { orderDetails, multibancoReference } = location.state || {};
  const navigate = useNavigate();

  useEffect(() => {
    // Entrada por URL direto: sem os dados do pagamento não há nada a mostrar
    // (era página em branco com TypeError) — voltar ao carrinho.
    if (!orderDetails || !multibancoReference) {
      navigate('/carrinho', { replace: true });
    }
  }, [orderDetails, multibancoReference, navigate]);

  if (!orderDetails || !multibancoReference) {
    return null;
  }

  return (
    <Container className="py-5">
      <Card className="text-center">
        <Card.Header style={{ backgroundColor: colors.primary, color: colors.dark }}>
          <h4>Pagamento Multibanco</h4>
        </Card.Header>
        <Card.Body>
          <Alert variant="info">
            <p>Por favor, utilize os seguintes dados para efetuar o pagamento:</p>
          </Alert>

          <div className="mb-4 p-4 border rounded bg-light">
            <h5>Dados do Pagamento</h5>
            <p>Encomenda: {orderDetails?.id}</p>
            <Row className="mb-3">
              <Col xs={4} className="fw-bold">
                Entidade:
              </Col>
              <Col xs={8}>{multibancoReference.entity}</Col>
            </Row>
            <Row className="mb-3">
              <Col xs={4} className="fw-bold">
                Referência:
              </Col>
              <Col xs={8}>{multibancoReference.reference}</Col>
            </Row>
            <Row>
              <Col xs={4} className="fw-bold">
                Valor:
              </Col>
              <Col xs={8}>{multibancoReference.amount}€</Col>
            </Row>
          </div>

          <p className="text-muted mb-4">
            Esta referência é válida por 48 horas. Após o pagamento, irá
            receber uma confirmação por e-mail.
          </p>

          <div className="d-flex justify-content-center gap-3">
            <Button 
              onClick={() => navigate('/minhas-encomendas')}
              style={{ 
                backgroundColor: colors.secondary,
                borderColor: colors.secondary,
                color: colors.light
              }}
            >
              Ver Minhas Encomendas
            </Button>
            <Button 
              variant="outline-secondary"
              onClick={() => navigate('/')}
              style={{ 
                borderColor: colors.secondary,
                color: colors.secondary
              }}
            >
              Continuar a Comprar
            </Button>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default MultibancoPaymentPage; 